import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

import Button from "@krea/customer-features/shared-components/button";
import { useLoanApplicationFormStore } from "@krea/customer-features/store/loan-application-form/hooks";
import { useModalStore } from "@krea/customer-features/store/modal/hooks";

import { useInitiateLoanApplication } from "store/loan-application-form/hooks";

import { RemoteIdentificationType } from "../../../../utils";

const CancelButton = ({ isSubmitting, setSubmitting }) => {
  const { t } = useTranslation();
  const closeModal = useModalStore(({ closeModal }) => closeModal);

  const { remoteIdentification, clearSsn, clearRemoteIdentification } =
    useLoanApplicationFormStore(
      useShallow(
        ({ clearSsn, clearRemoteIdentification, remoteIdentification }) => ({
          clearSsn,
          clearRemoteIdentification,
          remoteIdentification,
        }),
      ),
    );

  const { isPending, isFailed, cancelApplicationViaBankID, resetQuery } =
    useInitiateLoanApplication();

  const onCancelClick = () => {
    if (isPending) {
      setSubmitting(false);

      if (remoteIdentification?.type === RemoteIdentificationType.BANK_ID) {
        cancelApplicationViaBankID();
        clearSsn();
      }
    } else {
      if (isFailed) {
        resetQuery();
      }

      closeModal();
      clearRemoteIdentification();
    }
  };

  return (
    <Button
      variant="text"
      disabled={isPending && !isSubmitting}
      onClick={onCancelClick}
      id="modal-cancel-button"
      style={{ minHeight: 0 }}
    >
      {isPending ? t("bankIDFlow.abortLogin") : t("bankIDFlow.back")}
    </Button>
  );
};

export default CancelButton;
